import { request, Response } from '../utils';

export const resetPassword = (body: { username: string }): Response<null> =>
  request('reset-password', body);
